import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/file/explorer/:selectedFolderId?",
    name: "FileExplorer",
    component: () => import("./view/FMFileExplorer.vue"),
    meta: {
      rights: ["document.admin"],
    },
    props: (route) => ({
      selectedFolderId: !route.params.selectedFolderId ? -1 : Number(route.params.selectedFolderId),
    }),
  },
];

export default router;
